<template>
    <div class="uk-padding ">
        <div class="">
            <h2 class="uk-heading-bullet">General Requirements</h2>
            <div class="child-width-1-2@m" uk-grid>
                <div>
                    <dl class="uk-description-list uk-description-list-divider">
                        <dt>Master’s Programmes</dt>
                        <dd>
                            Regular admission - 3.0 GPA or above <br>
                            Provisional admission - Minimum GPA of 2.67 <br>
                            Conditional, and Non-Degree Seeking- Special Student 2.55-2.66 GPA <br>
                        </dd>
                    </dl>
                </div>
                <div>
                    <dl class="uk-description-list uk-description-list-divider">
                        <dt>Doctoral Programmes</dt>
                        <dd>
                            Regular admission - 3.3 GPA or above <br>
                            Provisional admission - minimum GPA of 3.0
                        </dd>
                    </dl>
                </div>

            </div>
            <p>
                To be admitted into the School of Graduate Studies, the applicant must have submitted:
            </p>
            <div class="uk-child-width-1-2@m" uk-grid>
                <div>
                    <ul class="uk-list uk-list-bullet">
                        <li>
                            Completed application
                        </li>
                        <li>
                            Statement of Purpose (Masters and Post-graduate Diploma 250 words; Doctoral 500 words, minimum)
                        </li>

                        <li>
                            Applicants whose GPA falls below this level may submit other evidence of their ability to successfully complete a graduate programme.
                            <span class="uk-text-muted uk-text-small"><br>
                                Such evidence may include grades and scores in post-baccalaureate courses, diplomas, certificates or a record of progressively higher work responsibilities.
                            </span>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul class="uk-list uk-list-bullet">

                        <li>
                            References (as per programme requirement)
                        </li>
                        <li>
                            Official transcript from previous institution(s) or passing score from an Alternate Entry Requirement; Examination or Professional Experience
                        </li>
                        <li>
                            Notarized copy of degree
                        </li>
                        <li>
                            Three passport size photos
                        </li>
                        <li>
                            Proof of payment for application fee
                        </li>
                    </ul>
                </div>
            </div>
            <p class="uk-text-small uk-text-primary">
                Conditions for Matriculation into individual departments and programmes may require that the applicant meets higher GPA requirements.
                <br>
                Refer to the admission requirements of individual colleges for special application deadlines and additional requirements.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GradRequirements"
    }
</script>

<style scoped>
    dt{
        font-size: large;
        font-weight: bold;
        color: teal;
    }
    dd{
        font-size: medium;
    }
    @media screen and (max-width:600px){


        h2{
            font-size: 1.1em !important;
        }
        dd{
            font-size: small;
        }
        dt{
            font-size: medium;
        }
        p,li{
            font-size: 0.8em !important;
        }
        img{
            height: 40px !important;
        }

    }
</style>
